import React from "react";
import { Dropdown } from "primereact/dropdown";
import { useFormik } from "formik";
import { feature, type } from "./assets";
import EsnSimSingleUpload from "./update_esn_sim/single_upload";
import EsnSimBulkUpload from "./update_esn_sim/bulk_upload";
import UpdateDeviceSingleUpload from "./update_device/single_upload";
import UpdateDeviceBulkUpload from "./update_device/bulk_upload";
import "./update_esn_sim/updateInventory.css";
const UpdateInventory = ({ permissions, setUpdateInventory }) => {
  const formik = useFormik({
    initialValues: {
      updatefeature: "",
      uploadtype: "",
    },
  });

  return (
    <div className="updateinventorymain">
      <div className="updateinventoryinner">
        <button
          className="backicon"
          onClick={() => {
            setUpdateInventory(false);
          }}
        >
          <i className="pi pi-angle-left"></i>
        </button>
        <h1>Update Inventory</h1>
        <p style={{ marginTop: "1.2rem" }}>
          Use the form below to update inventory details.
        </p>
        <div className="updateinventoryform">
          <div className="flex flex-column" style={{ gap: "1.2rem" }}>
            <div className="flex" style={{ gap: "1.2rem", height: "6.8rem" }}>
              <div className="calendar_field">
                <p className="field_label">
                  Update Feature <span className="steric">*</span>
                </p>
                <Dropdown
                  value={formik.values.updatefeature}
                  options={feature}
                  onChange={(e) =>
                    formik.setFieldValue("updatefeature", e.value)
                  }
                  placeholder="Select an option"
                  className="dropdown"
                  style={{
                    marginTop: ".2rem",
                    borderColor:
                      formik.values.updatefeature === ""
                        ? "#B9BBCC"
                        : "#9C9EB6",
                  }}
                />
              </div>
              <div className="calendar_field">
                <p className="field_label">
                  Upload Type <span className="steric">*</span>
                </p>
                <Dropdown
                  value={formik.values.uploadtype}
                  options={type}
                  onChange={(e) => formik.setFieldValue("uploadtype", e.value)}
                  placeholder="Select an option"
                  className="dropdown"
                  style={{
                    marginTop: ".2rem",
                    borderColor:
                      formik.values.uploadtype === "" ? "#B9BBCC" : "#9C9EB6",
                  }}
                />
              </div>
            </div>
            <div>
              {formik.values.updatefeature === "esnsim" &&
              formik.values.uploadtype === "single" ? (
                <EsnSimSingleUpload
                  permissions={permissions}
                  setUpdateInventory={setUpdateInventory}
                />
              ) : formik.values.updatefeature === "esnsim" &&
                formik.values.uploadtype === "bulk" ? (
                <EsnSimBulkUpload
                  permissions={permissions}
                  setUpdateInventory={setUpdateInventory}
                />
              ) : formik.values.updatefeature === "device" &&
                formik.values.uploadtype === "single" ? (
                <UpdateDeviceSingleUpload
                  permissions={permissions}
                  setUpdateInventory={setUpdateInventory}
                />
              ) : formik.values.updatefeature === "device" &&
                formik.values.uploadtype === "bulk" ? (
                <UpdateDeviceBulkUpload
                  permissions={permissions}
                  setUpdateInventory={setUpdateInventory}
                />
              ) : undefined}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateInventory;
